import React from 'react';

import * as analytics from 'analytics/Analytics';
import {WORKFLOWS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {isInaccessible as isInaccessibleGQL} from 'graphql-client/InaccessibleInfo';
import ProcessTaskChipPopoverContent from 'processes/chip-utils/ProcessTaskChipPopoverContents';
import {processTaskDetailsURL} from 'processes/dao/ProcessManagementDAO';
import ProcessTaskFileState from 'processes/process-task-details/ProcessTaskFileState';
import {
  createDirectFileOpenClickHandler,
  getSharedSmartChipProps,
  SharedSmartChipProps,
} from 'ui-library/chips/ChipUtil';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {BasicEvent} from 'util/Types';

import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export interface ProcessTaskChipProps extends SharedSmartChipProps<SmartChipType.PROCESS_TASK> {
  enableFancyChipPopoverContent?: boolean;
}

export default function ProcessTaskChip(props: ProcessTaskChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: processTask,
    handleClickLink,
    isInaccessible,
    itemUrl: processUrl,
  } = useSmartChipQuery<SmartChipType.PROCESS_TASK>({
    id,
    onClick,
    getUrlFn: (processTask) => processTaskDetailsURL(processTask.id),
  });
  const icon: BenchlingIconName | null = processTask != null ? 'process-task' : null;
  const enableFancyChipPopoverContent = props.enableFancyChipPopoverContent ?? true;

  const baseClickHandler = createDirectFileOpenClickHandler(processTask, onClick, handleClickLink, {
    onOpen: (fileState: ProcessTaskFileState) => {
      fileState.activateTaskDetailsTab();
    },
  });

  const onClickHandler = (e: BasicEvent): void => {
    baseClickHandler(e);
    analytics.trackEvent(WORKFLOWS_ANALYTICS_ACTIONS.CLICKED_TASK_OR_OUTPUT_CHIP, {
      process_client_origin:
        processTask?.taskSchema != null && !isInaccessibleGQL(processTask.taskSchema)
          ? processTask.taskSchema.clientOrigin
          : null,
    });
  };
  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={icon}
      isInaccessible={isInaccessible}
      item={processTask}
      onClick={onClickHandler}
      url={processUrl}
      popoverContentOverride={
        enableFancyChipPopoverContent && id != null ? (
          <ProcessTaskChipPopoverContent id={id} icon={icon} />
        ) : null
      }
    />
  );
}
